// src/pages/admin/Page_Educajob/Page_Educajob.js
//
// M08 - Pagina contenedora que agrupa las 5 secciones del front
// publico de educajob.net: Blog, Cursos, Menu del front, Newsletter,
// Usuarios Cursos.
//
// ESTRATEGIA "wrap, don't rewrite":
// - Cada tab renderiza el componente legacy existente SIN tocarlo.
// - El tab activo se sincroniza con ?tab=... en la URL (compartible).
// - Las URLs viejas (/admin/blog, /admin/menu, etc) redirigen aqui via
//   <Navigate> en AdminRouter.

import React, { useMemo } from "react";
import { Tabs } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ReadOutlined,
  AppstoreOutlined,
  MenuOutlined,
  MailOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { PageHeader, EducaThemeProvider } from "../../../ui";
import { Blog } from "../Page_WebCompEducajob/Blog";
import { Courses } from "../Page_WebCompEducajob/Courses";
import { Newsletter } from "../Page_WebCompEducajob/Newsletter";
import { Menu as MenuPage } from "../Menu";
import { UsersDB } from "../Page_ClientDB/UsersDB";
import styles from "./Page_Educajob.module.scss";

export const EDUCAJOB_TABS = [
  {
    key: "blog",
    label: "Blog",
    icon: <ReadOutlined />,
    render: () => <Blog />,
  },
  {
    key: "courses",
    label: "Cursos",
    icon: <AppstoreOutlined />,
    render: () => <Courses />,
  },
  {
    key: "menu",
    label: "Menu del front",
    icon: <MenuOutlined />,
    render: () => <MenuPage />,
  },
  {
    key: "newsletter",
    label: "Newsletter",
    icon: <MailOutlined />,
    render: () => <Newsletter />,
  },
  {
    key: "users",
    label: "Usuarios Cursos",
    icon: <TeamOutlined />,
    render: () => <UsersDB />,
  },
];

const DEFAULT_TAB = "blog";
const TAB_KEYS = new Set(EDUCAJOB_TABS.map((t) => t.key));

function normalizeTab(value) {
  return value && TAB_KEYS.has(value) ? value : DEFAULT_TAB;
}

export function Page_Educajob() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeKey = normalizeTab(searchParams.get("tab"));

  const items = useMemo(
    () =>
      EDUCAJOB_TABS.map((t) => ({
        key: t.key,
        label: (
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            {t.icon}
            {t.label}
          </span>
        ),
        children: t.render(),
      })),
    [],
  );

  const onChange = (key) => {
    navigate(`/admin/educajob?tab=${key}`, { replace: false });
  };

  return (
    <EducaThemeProvider>
      <div className={styles.pageEducajob}>
        <PageHeader
          title="Educajob"
          subtitle="Gestion del front publico de educajob.net (blog, cursos, menu, newsletter, usuarios de cursos)"
        />
        <div className={styles.tabsWrapper}>
          <Tabs
            activeKey={activeKey}
            onChange={onChange}
            items={items}
            destroyInactiveTabPane
          />
        </div>
      </div>
    </EducaThemeProvider>
  );
}
